var React = require('react');

function Icn02Dark (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".dark_02_a,.dark_02_b{fill:none;stroke:#121c25;stroke-miterlimit:10;stroke-width:2px;}.dark_02_a{opacity:0.5;}.dark_02_b{opacity:0.85;}")),React.createElement("polyline",{"className":"dark_02_a","points":"10.14 17.86 7.96 15.69 15.69 7.96 17.86 10.14","key":1}),React.createElement("polyline",{"className":"dark_02_b","points":"23.72 10.74 28.51 15.53 15.53 28.51 10.74 23.72","key":2}),React.createElement("polyline",{"className":"dark_02_a","points":"21.12 13.39 23.29 15.57 15.57 23.29 13.39 21.12","key":3}),React.createElement("polyline",{"className":"dark_02_b","points":"7.54 20.52 2.75 15.73 15.73 2.75 20.52 7.54","key":4})]);
}

Icn02Dark.defaultProps = {"viewBox":"0 0 31.26 31.26"};

module.exports = Icn02Dark;

Icn02Dark.default = Icn02Dark;
